/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_UnpinInputs */

const cs_chat_unpin = /** @type {(inputs: Chat_UnpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odepnout konverzaci`)
};

const en_chat_unpin = /** @type {(inputs: Chat_UnpinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unpin conversation`)
};

/**
* | output |
* | --- |
* | "Unpin conversation" |
*
* @param {Chat_UnpinInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_unpin = /** @type {((inputs?: Chat_UnpinInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_UnpinInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_unpin(inputs)
	return cs_chat_unpin(inputs)
});